import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
export var BaseStore = /*#__PURE__*/function () {
  function BaseStore() {
    _classCallCheck(this, BaseStore);
    this._state = void 0;
    this.observers = void 0;
    this.observers = [];
  }
  _createClass(BaseStore, [{
    key: "state",
    get: function get() {
      return this._state;
    }
  }, {
    key: "setState",
    value: function setState(state) {
      this._state = state;
      this.emitState();
    }
  }, {
    key: "initState",
    value: function initState(state) {
      this._state = state;
    }
  }, {
    key: "emitState",
    value: function emitState() {
      var _this = this;
      this.observers.forEach(function (ob) {
        ob(_this.state);
      });
    }
  }, {
    key: "subscribe",
    value: function subscribe(func) {
      var _this2 = this;
      if (this.observers.indexOf(func) < 0) {
        this.observers.push(func);
        func(this.state);
      }
      return function () {
        var index = _this2.observers.indexOf(func);
        if (index > -1) {
          _this2.observers.splice(index, 1);
        }
      };
    }
  }]);
  return BaseStore;
}();
BaseStore.__is_base_provider__ = true;